module.exports = __webpack_public_path__ + "img/fire.ddde4a45.svg";